// extracted by mini-css-extract-plugin
module.exports = {"rotation":"ProgettiHubTemplate_rotation__Y1j9U"};